import React from "react";

export default function ApprovedContractorHeader() {
  return (
    <div className="approved-contractors-header">
      <h1 className="page_title">SEWP Approved Support Service Contractors</h1>
        
          <div className="content p_content" title="help text">
            <p>
              The following Federal Contractors are approved to purchase from the SEWP contracts in support of their Federal Contract Number(s) through the Contract Period Of Performance Dates as listed below.
            </p>
            <p>
              <a href="/ordering.shtml#WHO">How To Become a NASA SEWP Approved Support Service Contractor?</a>
            </p>
          </div>
        
    </div>
  );
}
